/**
 * Module Router
 * 
 * Automatically loads and merges routes from all registered modules
 */

import type { RouteObject } from 'react-router-dom';
import { getAllModuleRoutes } from '../modules';

/**
 * Get all routes from modules
 */
export function getModuleRoutes(): RouteObject[] {
  return getAllModuleRoutes();
}

/**
 * Merge module routes with base routes
 */
export function mergeRoutes(baseRoutes: RouteObject[], moduleRoutes: RouteObject[]): RouteObject[] {
  // Merge routes, with module routes taking precedence for same paths
  const merged: RouteObject[] = [...baseRoutes];

  moduleRoutes.forEach(moduleRoute => {
    const existingIndex = merged.findIndex(r => r.path === moduleRoute.path);
    if (existingIndex >= 0) {
      // Merge children if both have children
      if (merged[existingIndex].children && moduleRoute.children) {
        // Create a map to track unique children by path
        const childrenMap = new Map<string, RouteObject>();

        // Add existing children
        merged[existingIndex].children?.forEach(child => {
          const key = child.path || (child.index ? '__index__' : `__${childrenMap.size}__`);
          childrenMap.set(key, child);
        });

        // Add/override with module children
        moduleRoute.children.forEach(child => {
          const key = child.path || (child.index ? '__index__' : `__${childrenMap.size}__`);
          childrenMap.set(key, child);
        });

        merged[existingIndex].children = Array.from(childrenMap.values());
      } else {
        // Replace existing route
        merged[existingIndex] = moduleRoute;
      }
    } else {
      // Add new route
      merged.push(moduleRoute);
    }
  });

  return merged;
}

